import { useEffect, useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getMe, updateAddress } from '../api/client'
import { extractErrorMessage } from '../api/errors'

export function Address() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [city, setCity] = useState('')
  const [street, setStreet] = useState('')
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    getMe()
      .then((u) => {
        setCity(u.address.city)
        setStreet(u.address.street)
      })
      .catch((err) => setError(extractErrorMessage(err)))
      .finally(() => setLoading(false))
  }, [])

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setError(null)
    setSaving(true)
    try {
      await updateAddress(city.trim(), street.trim())
      navigate('/')
    } catch (err) {
      setError(extractErrorMessage(err))
    } finally {
      setSaving(false)
    }
  }

  if (loading) return <p className="screen__hint">{t('home.loading')}</p>

  return (
    <div className="screen">
      <h1 className="screen__title">{t('address.title')}</h1>

      {error && <p className="screen__error">{error}</p>}

      <form onSubmit={handleSubmit} className="form">
        <label className="field">
          <span className="field__label">{t('address.city_label')}</span>
          <input
            className="field__input"
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder={t('address.city_placeholder')}
            maxLength={100}
            autoComplete="off"
          />
        </label>

        <label className="field">
          <span className="field__label">{t('address.street_label')}</span>
          <input
            className="field__input"
            type="text"
            value={street}
            onChange={(e) => setStreet(e.target.value)}
            placeholder={t('address.street_placeholder')}
            maxLength={100}
            autoComplete="off"
          />
        </label>

        <p className="field__hint">{t('address.example')}</p>

        <button type="submit" className="btn btn--primary" disabled={saving}>
          {saving ? t('address.saving') : t('address.save')}
        </button>
      </form>
    </div>
  )
}
